import { AppHeaderContext } from '@deltek/specification-client/core/Contexts/AppHeaderContext'
import BanneredPage from 'bpm/pages/components/BanneredPage'
import React from 'react'
import ProductHeader from '../components/ProductHeader'

const SubmissionPage: React.FC = () => {
    const { updateAppHeaderContent } = React.useContext(AppHeaderContext)

    React.useEffect(() => {
        updateAppHeaderContent('Submissions', <ProductHeader />)
    }, [updateAppHeaderContent])
    return <BanneredPage heading="Submissions">Submissions Page</BanneredPage>
}

export default SubmissionPage
